<template>
    <div>
        <a-row>
            <a-col :span="1">
                <a-button type="primary" @click="visible=true">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;" @click="editRole(row)">编辑角色</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="del(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible"
                 title="编辑用户信息"
                 width="60%"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="add"
                 @cancel="resetForm">
            <a-form-model ref="userForm" :rules="rules" :model="form" :label-col="{ span: 7 }"
                          :wrapper-col="{ span: 17 }">
                <a-row>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="用户账号" prop="account">
                            <a-input v-model="form.account"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="用户密码" prop="pass">
                            <a-input v-model="form.pass"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="用户名称" prop="name">
                            <a-input v-model="form.name"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="用户部门" prop="groupId">
                            <my-select-tree :tree-value.sync="form.groupId" :data-list="orgList"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="用户描述">
                            <a-input v-model="form.descpt"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="电子邮箱">
                            <a-input v-model="form.email"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="用户电话">
                            <a-input v-model="form.phone"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="用户手机号">
                            <a-input v-model="form.mobile"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="权限级别" prop="level">
                            <my-select :select-value.sync="form.level" :data-list="dataPowerLevelList"/>
                        </a-form-model-item>
                    </a-col>
                    <a-col span="1"/>
                    <a-col span="10">
                        <a-form-model-item label="部门数组">
                            <my-select-tree :tree-value.sync="form.departList" :data-list="orgList" :multiple="true"/>
                        </a-form-model-item>
                    </a-col>
                </a-row>
            </a-form-model>
        </a-modal>
        <a-modal v-model="roleVisible"
                 title="编辑用户具有角色"
                 width="60%"
                 :bodyStyle="{height: '60vh'}"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="addRole"
                 @cancel="resetForm">
            <a-spin :spinning="spinning">
                <a-tree
                        v-model="selectRoleList"
                        :checkable="true"
                        style="min-height:55vh;max-height:55vh;overflow:scroll;"
                        :replaceFields="{title:'name', key:'id'}"
                        :auto-expand-parent="true"
                        :tree-data="roleList"
                />
            </a-spin>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
import {getUserQueryList,userEditDetail,userDelDetail,userQueryRoleByUserId,userEditRoleByUserId,getRoleQueryList} from "./js/ApiRole";
import {getDataPowerLevel} from "../../config/LookUpCache";
import {getDepartment} from "../../config/OrdinaryCache";
import notification from "ant-design-vue/es/notification";
    const columns = [
        {
            title: '用户账号',
            dataIndex: 'account',
            key: 'userAccount',
            ellipsis: true,
        },
        // {
        //     title: '用户密码',
        //     dataIndex: 'pass',
        //     key: 'userPass',
        //     ellipsis: true,
        // },
        {
            title: '用户名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '用户部门',
            dataIndex: 'suGroup.name',
            key: 'suGroup.name',
            ellipsis: true,
        },
        {
            title: '用户描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '用户电子邮箱',
            dataIndex: 'email',
            key: 'email',
            ellipsis: true,
        },
        {
            title: '用户电话',
            dataIndex: 'phone',
            key: 'phone',
            ellipsis: true,
        },
        {
            title: '用户手机号',
            dataIndex: 'mobile',
            key: 'mobile',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            align: 'center',
            width: '200px',
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                selectRoleList: [],
                roleList: [],
                data: {},
                roleVisible: false,
                delVisible: false,
                visible: false,
                // 部门
                orgList: [],
                // 权限级别
                dataPowerLevelList: [],
                rules: {
                    account: [{required: true, message: '请输入用户账号', trigger: 'blur'}],
                    name: [{required: true, message: '请输入用户名称', trigger: 'blur'}],
                    pass: [{required: true, message: '请输入用户密码', trigger: 'blur'}],
                    groupId: [{required: true, message: '请选择用户部门', trigger: 'change'}],
                    level: [{required: true, message: '请选择数据权限级别', trigger: 'blur'}],
                },
                form: {
                    account: '',
                    pass: '',
                    name: '',
                    groupId: '',
                    descpt: '',
                    email: '',
                    mobile: '',
                    level: '',//数据权限级别
                    departList: []//可查看部门数据列表用“,”分隔
                },
                spinning: false,
                line: {}
            }
        },
        methods: {
            //新增
            add() {
                this.$refs.userForm.validate(valid => {
                    if (valid) {
                        this.form.departList = this.form.departList.join(',');
                        userEditDetail(this.form).then(() => {
                            this.getData()
                        })
                    }
                });
            },
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.form.departList = this.form.departList.split(',');
                this.visible = true
            },
            editRole(row) {
                this.spinning = true;
                this.line = row;
                userQueryRoleByUserId({id: row.id}).then(res => {
                    this.spinning = false;
                    if (res.data.data.suRoles) {
                        let roleList = [];
                        res.data.data.suRoles.forEach(item => {
                            roleList.push(item.id)
                        });
                        this.selectRoleList = roleList;
                    }
                    this.roleVisible = true
                }).catch(() => {
                    this.spinning = false;
                    this.roleVisible = false;
                    notification.error({
                        message: '用户角色加载失败，请检查网络环境',
                    });
                });
            },
            addRole() {
                let selectRoleList = [];
                this.selectRoleList.forEach(item => {
                    let role = this.roleList.find(item2 => {
                        return item2.id === item
                    });
                    if (role) {
                        selectRoleList.push(role);
                    }
                });
                this.line.roles = selectRoleList;
                userEditRoleByUserId(this.line).then(() => {
                    this.getData();
                })
            },
            //删除
            del(row) {
                this.delVisible = true;
                this.line = row;
            },
            delOk(){
                userDelDetail({id: this.line.id}).then(() => {
                    this.getData();
                    this.delVisible = false;
                }).catch(()=>{
                    this.delVisible = false;
                })
            },
            cancel(){
                this.delVisible = false;
            },
            getData(parameter) {
                this.resetForm();
                if (parameter === null || parameter === undefined) {
                    parameter = {}
                }
                getUserQueryList(parameter).then(res => {
                    this.data = res.data;
                    this.visible = false;
                    this.roleVisible = false
                })
            },
            /**
             * 重置form
             */
            resetForm() {
                if (this.$refs.userForm !== undefined) {
                    this.$refs.userForm.clearValidate();
                }
                this.selectRoleList = [];
                this.row = {};
                this.form = {
                    account: '',
                    pass: '',
                    name: '',
                    groupId: '',
                    descpt: '',
                    email: '',
                    mobile: '',
                    level: '',//数据权限级别
                    dataPowerOrgList: []//可查看部门数据列表用“,”分隔
                }
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                getUserQueryList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
        },
        created() {
            this.getData();
            getDepartment(res => {
                this.orgList = res;
            });
            getDataPowerLevel(res => {
                this.dataPowerLevelList = res;
            });
            getRoleQueryList({}).then(res => {
                this.roleList = res.data.data
            });
        }
    }
</script>

<style scoped>
    .Tips{
        font-size: 20px;
        color: #1890ff;
    }
</style>
